/**
 * Asynchronously loads the component for UploadDataGridPage
 */

import { lazyLoad } from 'utils/loadable';

export const UploadDataGridPage = lazyLoad(
  () => import('./index'),
  module => module.UploadDataGridPage,
);
